import React, { useMemo, useState } from 'react';
import { Button, MultiselectGroup } from '@pinwheel/origami';
import { useDispatch } from 'react-redux';
import { setIncomeSourceBenefits } from '../../state/slices/slice-wizard';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import BaseWizardScreen from './BaseWizardScreen';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
export default function WizardIncomeSourceBenefits() {
    var navigate = useLinkNavigate();
    var dispatch = useDispatch();
    var getLocalizedString = useGetLocalizedString();
    var _a = useState(null), tempBenefitsState = _a[0], setTempBenefitsState = _a[1];
    var body = useMemo(function () { return (React.createElement(MultiselectGroup, { options: [
            {
                value: 'supplemental',
                label: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_SUPPLEMENTAL'),
            },
            {
                value: 'ssr',
                label: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_SSR'),
            },
            {
                value: 'unemployment',
                label: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_UNEMPLOYMENT'),
            },
            {
                value: 'pension',
                label: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_PENSION'),
            },
            {
                value: 'military',
                label: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_MILITARY'),
            },
            {
                value: 'other',
                label: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_OTHER'),
            },
        ], onChange: function (e) {
            setTempBenefitsState({
                visited: true,
                benefitsSources: e.map(function (p) { return p.value; }),
            });
        } })); }, [getLocalizedString]);
    var button = useMemo(function () {
        var _a;
        return (React.createElement(Button, { dataTestId: "Continue", disabled: tempBenefitsState === null ||
                ((_a = tempBenefitsState.benefitsSources) === null || _a === void 0 ? void 0 : _a.length) === 0, onClick: function () {
                if (tempBenefitsState) {
                    dispatch(setIncomeSourceBenefits(tempBenefitsState));
                }
                return navigate('/search/search');
            } }, getLocalizedString('CONTINUE')));
    }, [tempBenefitsState, getLocalizedString, dispatch, navigate]);
    return (React.createElement(BaseWizardScreen, { dataTestId: "Wizard-IncomeSourceBenefits", titleText: getLocalizedString('WIZARD_INCOME_SOURCE_BENEFITS_TITLE'), subtitleText: getLocalizedString('CHECK_ALL_THAT_APPLY'), buttons: button }, body));
}
